const maping = {
  index: {
    title: '惠州得胜彩印有限公司',
    metaTags: [
      {
        name: 'keywords',
        content: '彩盒,彩卡,高档精品盒,手挽袋,产品说明书,吊牌,宣传画册,宣传彩页,不干胶贴纸,环保展示柜,纸箱',
      },
      {
        name: 'description',
        content: '惠州得胜彩印有限公司主要业务有彩盒,彩卡,高档精品盒,手挽袋,产品说明书,吊牌,宣传画册,宣传彩页,不干胶贴纸,环保展示柜,纸箱',
      },
    ]
  },
};

export default maping;



// WEBPACK FOOTER //
// ./src/router/meta.js